
// Libraries
import { OnInit } from '@angular/core';
import * as lodash from 'lodash';

/**
 * `Paginable` implements a concern to manage pagination.
 */
export abstract class Paginable implements OnInit {
  // Public properties
  /**
   * Current page.
   */
  public currentPage = 1;
  /**
   * Per page.
   */
  public perPage = 10;
  /**
   * Total count.
   */
  public totalCount = 0;

  // Private properties
  /**
   * Storage prefix
   */
  private storagePrefix = 'pagination';
  /**
   * Save pagination
   */
  private savePagination: boolean;

  /**
   * Creates a new `Paginable` instance.
   * @param sPrefix Prefix to save pagination
   * @param sPagination Save or not pagination
   */
  constructor(
    private sPrefix: string,
    private sPagination: boolean
  ) {
    this.storagePrefix = this.sPrefix;
    this.savePagination = this.sPagination;
  }

  // Public methods
  /**
   * On init method
   */
  public ngOnInit(): void {
    // Check if save pagination
    if (this.savePagination) {
      // Get current page from local storage
      this.getCurrentPage();
    }
  }

  /**
   * Handles on page change event.
   * @param currentPage Current page
   */
  public onPageChange(currentPage: number): void {
    this.currentPage = currentPage;
    if (this.savePagination) {
      // Save current page on local storage
      this.saveCurrentPage();
    }
  }

  /**
   * Copy pagination data from meta object
   * @param meta Meta object
   * @return True if need refresh current page
   */
  public copyMetaData(meta: any): boolean {
    let update = false;
    if (meta) {
      // Check if current page is smaller than total pages
      if (meta.currentPage > meta.totalPages) {
        this.currentPage = 1;
        if (this.savePagination) {
          // Save current page on local storage
          this.saveCurrentPage();
        }
        update = true;
      } else {
        this.currentPage = parseInt(meta.currentPage, 10);
      }
      // Copy meta data
      this.totalCount = meta.totalCount;
      this.perPage = meta.perPage;
    } else {
      this.totalCount = 0;
      this.currentPage = 0;
    }

    return update;
  }

  // Private methods
  /**
   * Save current page on local storage
   */
  private saveCurrentPage(): void {
    // Save value on local storage
    localStorage.set(this.storagePrefix + '-current-page', this.currentPage);
  }

  /**
   * Get current page from local storage
   */
  private getCurrentPage() {
    const currentPage = parseInt(localStorage.get(this.storagePrefix + '-current-page'), 10);
    // Check if current page saved is number, then trigger page change event
    if (!lodash.isNaN(currentPage) && this.currentPage !== currentPage) {
      this.currentPage = currentPage;
    }
  }
}
